import { Dialog } from "@mui/material";
import SavedLocation, { SavedLocationSelectionType } from "./SavedLocation";
import "./index.css";
import { useState } from "react";
import AddEditSavedLocation from "./AddEditSavedLocation";
import ManageSavedLocations from "./ManageSavedLocations";
import AddDeliveryLocation from "./AddDeliveryLocation";
import { CustomerDeliveryLocation } from "dora-contracts";

const ManageSavedLocationsDialog = ({
  onClose,
  addTerminalOnly,
  customerDeliveryAddresses,
  clientId,
}: {
  onClose: () => void;
  addTerminalOnly?: boolean;
  customerDeliveryAddresses?: CustomerDeliveryLocation[];
  clientId?: string;
}) => {
  const [type, setType] = useState<SavedLocationSelectionType>("FAVORITE");
  const [savedLocationForDialog, setSavedLocationForDialog] = useState<
    SavedLocation | "NEW" | null
  >(addTerminalOnly ? "NEW" : null);

  const onAddButtonClick = () => setSavedLocationForDialog("NEW");

  return (
    <Dialog open onClose={onClose}>
      {savedLocationForDialog ? (
        type === "DELIVERY_ADDRESS" && clientId ? (
          <AddDeliveryLocation
            clientId={clientId}
            onClose={onClose}
            onBack={() => setSavedLocationForDialog(null)}
            onTypeChange={setType}
          />
        ) : (
          <AddEditSavedLocation
            addTerminalOnly={addTerminalOnly}
            location={savedLocationForDialog}
            type={type === "DELIVERY_ADDRESS" ? "FAVORITE" : type}
            clientId={clientId}
            onClose={onClose}
            onBack={() => setSavedLocationForDialog(null)}
            onDeliveryTypeClick={() => setType("DELIVERY_ADDRESS")}
          />
        )
      ) : (
        <ManageSavedLocations
          onClose={onClose}
          type={type}
          onTypeChange={setType}
          onAddClick={onAddButtonClick}
          onEditClick={(location) => setSavedLocationForDialog(location)}
          customerDeliveryAddresses={customerDeliveryAddresses}
          clientId={clientId}
        />
      )}
    </Dialog>
  );
};

export default ManageSavedLocationsDialog;
